import { sha256 } from '@noble/hashes/sha2.js';
import { bytesToHex, utf8ToBytes } from '@noble/hashes/utils.js';

/**
 * Wire format for login and payment passwords: SHA-256(UTF-8 string) as 64 lowercase hex digits.
 * The server stores bcrypt(SHA-256 digest), never the raw password.
 *
 * Uses @noble/hashes (not `crypto.subtle`) so this works on http://LAN-IP and other
 * non-secure contexts where `SubtleCrypto` is undefined.
 */
export async function sha256Utf8Hex(plain: string): Promise<string> {
  return bytesToHex(sha256(utf8ToBytes(plain)));
}
